export default __webpack_public_path__ + "static/SourceSansPro-BoldItalic-7c4f9b00300acb82f0f6f980b1e87b39.ttf";